/**
 * Neutral outlined actions (border + white fill) — same family as Agentic room
 * header ``Members`` / ``Pool context`` and the Network Workbench toolbar.
 */
export const WORKBENCH_OUTLINE_BTN_TOOLBAR =
  'inline-flex items-center gap-1.5 rounded-md border border-gray-300 bg-white px-2.5 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50';

export const WORKBENCH_OUTLINE_BTN_MODAL =
  'inline-flex items-center justify-center gap-1.5 rounded-md border border-gray-300 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50';

export const WORKBENCH_OUTLINE_BTN_MODAL_LG =
  'inline-flex items-center justify-center gap-1.5 rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50';
